/* eslint-disable react/jsx-no-bind */

import { Route, BrowserRouter as Router, Switch, useLocation } from 'react-router-dom';
import React, { Suspense, useEffect, useState } from 'react';
import Loading from 'shared/loader/Loading';
import ProjectsPage from 'pages/ProjectsPage/ProjectsPage';
import paths from 'paths';
import NotFound from 'pages/NotFoundPage/NotFound';
import PackagesPage from 'pages/PackagesPage/PackagesPage';
import { setAction } from 'redux/actions/profile';
import { useDispatch } from 'react-redux';
import { getTeamIdAction } from 'pages/ProjectsPage/actions/projectsPage';

const licenseQueryParam = 'everviz_licenseid';

function RootContainer() {
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const [licenseId] = useState(queryParams.get(licenseQueryParam));

  useEffect(() => {
    console.log(1234, licenseId);
    dispatch(setAction({ licenseId }));
    dispatch(getTeamIdAction({ licenseId }));
  }, [licenseId]);

  useEffect(() => {
    function setCrossDomainCookie(name: string, value: string) {
      // Create the cookie string with necessary attributes
      const cookieString = `${name}=${value}; Domain=app.everviz.com; path=/; Secure; SameSite=None`; // Allow the cookie to be sent with cross-site requests

      // Set the cookie
      document.cookie = cookieString;
    }

    function setCookie(cookieName: string, cookieValue: string) {
      // Default parameters
      var expiresInDays = 0; //arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0; // Expiration days
      var domain = '.everviz.com'; //arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : i._ckyStore._rootDomain; // Domain

      // Create a new Date object
      var currentDate = new Date();
      var expiresAt =
        0 === expiresInDays ? 0 : currentDate.setTime(currentDate.getTime() + 24 * expiresInDays * 60 * 60 * 1000); // Set expiration time (milliseconds)

      console.log('setting2::');
      // Set the cookie string
      document.cookie = ''
        .concat(cookieName, '=')
        .concat(cookieValue, '; expires=')
        .concat(new Date(expiresAt).toUTCString(), '; path=/; domain=')
        .concat(domain, '; SameSite=Strict; secure');
    }

    // Example usage
    setCookie('everviz-test', 'abcdef');
  }, []);

  return (
    <div className="row">
      <Suspense fallback={<Loading text="Loading team..." />}>
        <Switch>
          <Route exact={true} path={paths.profileProjects} render={(props) => <ProjectsPage />} />;
          <Route exact={true} path={paths.profilePackages} render={(props) => <PackagesPage />} />;
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </div>
  );
}

export default RootContainer;
